import {ActionIcon, Collapse} from '@mantine/core';
import {useDisclosure} from '@mantine/hooks';
import {MdClose, MdExpandMore} from 'react-icons/md';
import {cn} from '../../../../../../lib/classname';
import {useMissionsVisibility} from '../../../../usecase/useMissionsVisibility';
import {MissionItem, type MissionsListProps} from './MissionsList';

export type MissionsIconButtonProps = MissionsListProps;

export const MissionsCollapse: React.FC<MissionsIconButtonProps> = ({
  missions,
}) => {
  const [opened, {toggle}] = useDisclosure(false);
  const {isHidden, handleClose: handleCloseHook} = useMissionsVisibility();

  const currentMission = missions.find(
    (mission) => mission.completed === false,
  );
  const missionsWithoutCurrent = missions.filter(
    (mission) => mission !== currentMission,
  );
  const unCompletedMissionsCount = missions.filter(
    (mission) => !mission.completed,
  ).length;

  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    handleCloseHook(unCompletedMissionsCount);
  };

  if (isHidden) {
    return null;
  }

  return (
    <div className="px-16 py-12 bg-white rounded-16">
      <button
        className="w-full flex flex-col items-start"
        onClick={toggle}
        type="button"
        aria-label="チュートリアルリストを展開"
        aria-expanded={opened}
      >
        <div className="w-full flex items-center justify-between text-xs">
          {`残りチュートリアル ${unCompletedMissionsCount} / ${missions.length}`}
          <ActionIcon
            variant="transparent"
            onClick={handleClose}
            aria-label="チュートリアルを閉じる"
          >
            <MdClose size={12} />
          </ActionIcon>
        </div>
        <div className="w-full flex items-center justify-between">
          {currentMission ? (
            <MissionItem mission={currentMission} disableTooltip />
          ) : (
            <div className="text-sm text-success">
              すべてのチュートリアルを達成しました！
            </div>
          )}
          <ActionIcon variant="transparent" aria-label="チュートリアル詳細">
            <MdExpandMore
              size={20}
              className={cn('transition-transform duration-200', {
                'rotate-180': opened,
              })}
            />
          </ActionIcon>
        </div>
      </button>
      <Collapse in={opened}>
        <div className="flex flex-col gap-4 p-4">
          {missionsWithoutCurrent.map((mission) => (
            <MissionItem key={mission.id} mission={mission} disableTooltip />
          ))}
        </div>
      </Collapse>
    </div>
  );
};
